module.exports = __webpack_public_path__ + "img/auto-pipeline.91212b78.png";